export default "__VITE_ASSET__BWHvMR2___"